import React from "react";

const DoubleThumbsUp = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/2000/xlink"
    >
        <path
            d="M4.163 20.336h3.48V34h-3.48c-.31 0-.601-.12-.822-.33-.22-.22-.341-.51-.341-.81V21.477a1.143 1.143 0 0 1 1.163-1.14Zm6.127-1.47 7.41-7.292c.1-.1.23-.16.371-.17.14-.01.28.03.391.11l.993.73c.27.2.481.48.591.8.11.32.13.66.04.99l-1.333 5.162h7.41c.612 0 1.203.24 1.634.67.432.43.682 1.01.682 1.61v2.401c0 .3-.06.59-.17.87l-3.59 8.563c-.09.21-.24.39-.431.51-.18.11-.411.18-.632.18H11.112c-.31 0-.602-.12-.822-.33-.22-.21-.341-.5-.341-.81V19.666c0-.3.12-.59.34-.8Z"
            className="u_fill"
            fill={fill}
        />
        <path
            d="M32.51 10.804a2.364 2.364 0 0 0-1.664-.69h-7.55l1.363-5.372c.09-.34.07-.7-.05-1.03-.12-.33-.331-.62-.602-.83l-1.003-.76a.564.564 0 0 0-.4-.12c-.141.01-.271.07-.372.17l-7.55 7.592c-.22.22-.341.52-.341.84v1.49l1.965-1.94a2.63 2.63 0 0 1 1.635-.74c.611-.05 1.223.13 1.724.5l.993.73a3.67 3.67 0 0 1 1.294 1.74c.25.7.28 1.44.1 2.16l-.692 2.662h4.823c1.153 0 2.226.44 3.048 1.24a4.28 4.28 0 0 1 1.274 3.04v.6l2.537-6.19c.12-.29.18-.59.18-.901v-2.5c-.02-.65-.27-1.251-.712-1.691Z"
            className="u_fill"
            fill={fill}
        />
    </svg>
);

export default DoubleThumbsUp;


